import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';

import CollapseContainer from './CollapseContainer';
import { Toggler, ImageWithBlur } from '../../../../components';

import makeUrl from '../../../../lib/makeUrl';
import { showFormattedDate } from './utils';
import { roundOff, removeSpaces } from '../../../../lib/utils';

import { ServicesLodgeDetails as Icons } from '../../../../constants/icons';

type LodgesProps = {
  lodgings: Array<Object>,
  paymentType: string,
  trekTemplateStartDate: string,
  startDate: string,
  // props comes from Review
  totalLodgePrice: number,
};

const mapStateToProps = ({
  trekPayment: { lodgings, paymentType, trekTemplateStartDate },
}) => ({
  lodgings,
  paymentType,
  startDate: trekTemplateStartDate,
});

const Lodges = ({ totalLodgePrice, lodgings, paymentType, startDate }: LodgesProps) => (
  <CollapseContainer key="lodges-container" title={'Lodges '} cost={totalLodgePrice}>
    {lodgings.map(lodge => (
      <LodgeBreakdown
        data={lodge}
        noOfPeople={1}
        paymentType={paymentType}
        key={`${lodge.id}-${lodge.day}`}
        trekTemplateStartDate={startDate}
      />
    ))}
  </CollapseContainer>
);

export default connect(mapStateToProps)(Lodges);

type Data = {
  day: number,
  name: string,
  date: string,
  address: string,
  currency: string,
  roomType: string,
  mealPlan: Object,
  coverImages: Image,
  services: Array<String>,
  includedServices: Object,
};

type Props = {
  data: Data,
  currency: string,
  noOfPeople: number,
  paymentType: string,
  trekTemplateStartDate: string | null,
};

function LodgeBreakdown(props: Props) {
  const {
    id,
    day,
    name,
    address,
    services,
    mealPlan,
    roomType,
    coverImages,
    includedServices,
    currency,
  } = props.data;

  const { trekTemplateStartDate } = props;

  const includedServicesFromRoomType = includedServices ? includedServices[roomType] : '';
  const serviceWithCharge =
    services && services.length === 0 ? services.filter(service => service.doorCharge) : [];

  const includedServicesWithCharge = serviceWithCharge.filter(service =>
    includedServicesFromRoomType.includes(service.name.toLowerCase())
  );

  const lodgeCost = mealPlan && roomType ? mealPlan[roomType.toLowerCase()] || {} : {};
  const isCostAvailable = Boolean(lodgeCost.amount);

  const linkToLodgeDetails = makeUrl.goToLodgeDetails(name, id, address);

  return (
    <div className="container">
      <div className="row ">
        <div className="col-12 col-sm-3 col-md-3 small-image-wrap">
          <div className="lodge-img-wrap">
            <ImageWithBlur images={coverImages} name={name} showImageType="small" />
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-9 col-lg-9  review-day-wrap">
          <div className="row review-head">
            <div className="col-md-8 col-12">
              {showFormattedDate(trekTemplateStartDate, day)}
            </div>
            <div className="col-md-4 col-12 text-md-right">DAY {day}</div>
          </div>
          <div className="row review-body">
            <div className="col-md-8 places">
              <ol>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href={linkToLodgeDetails}>
                    {name},{address}
                  </a>
                </li>
              </ol>
            </div>
            <div className="col-md-4 price text-md-right">
              {isCostAvailable ? (
                <Fragment>
                  {`${currency} ${roundOff(Number(lodgeCost.amount), 2)}`}
                  <small>/ per person</small>
                </Fragment>
              ) : (
                <Fragment>
                  <span className="error">Booking not available for this lodge.</span>
                </Fragment>
              )}
            </div>
          </div>
          <div className="row review-foot">
            <div className="col-md-8">
              <ul className="facility-list clearfix">
                {includedServices &&
                  roomType &&
                  includedServices[roomType.toLowerCase()] &&
                  includedServices[roomType.toLowerCase()].map(service => {
                    if (service === 'dinner')
                      return (
                        <li key={service} className={provideIcon(service)}>
                          {' '}
                          {service} (soup and main entree)
                        </li>
                      );
                    if (service === 'breakfast')
                      return (
                        <li key={service} className={provideIcon(service)}>
                          {' '}
                          set breakfast
                        </li>
                      );

                    return (
                      <li key={service} className={provideIcon(service)}>
                        {' '}
                        {service}
                      </li>
                    );
                  })}
              </ul>
            </div>
            <Toggler initialOn={true}>
              {({ on, toggle }) => (
                <div className="col-md-4 show-more text-md-right">
                  {includedServicesWithCharge.length === 0 ? null : (
                    <p onClick={toggle}>
                      {on
                        ? [
                            'Hide Price Breakdown ',
                            <i className="icon icon-hg-chev-up" key={1} />,
                          ]
                        : [
                            'Show Price Breakdown ',
                            <i className="icon icon-hg-chev-down" key={2} />,
                          ]}
                    </p>
                  )}
                  <Collapse isOpen={on}>
                    {includedServicesWithCharge.map(service => {
                      const { doorCharge, name } = service;
                      const { cost } = doorCharge;

                      return (
                        <div key={name} className="in-list d-flex justify-content-between">
                          <p>{name}</p>
                          <p>
                            {cost.currency} {cost.amount}
                          </p>
                        </div>
                      );
                    })}
                  </Collapse>
                </div>
              )}
            </Toggler>
          </div>
        </div>
      </div>
    </div>
  );
}

const provideIcon = (serviceName: string): string => {
  serviceName = removeSpaces(serviceName).toLowerCase();
  return Icons[serviceName] ? Icons[serviceName] : Icons.default;
};



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/Lodges.js